<template>
  <div>
    <!-- PRODUCT DETAIL -->
    <section class="py-9">
      <div class="container" v-if="produtDetail">
        <div class="row g-4">

          <!-- Product Images -->
          <div class="col-lg-6">
            <div class="border rounded p-3">

              <!-- Main Image -->
              <img
                :src="activeImage"
                class="img-fluid rounded w-100 mb-3"
                alt="Product"
              />

              <!-- Thumbnails -->
              <div class="d-flex gap-2">
                <img
                  v-for="(img, index) in produtDetail.images"
                  :key="index"
                  :src="img"
                  class="img-thumbnail"
                  style="width: 80px; cursor: pointer;"
                  @click="activeImage = img"
                />
              </div>

            </div>
          </div>

          <!-- Product Info -->
          <div class="col-lg-6 text-start">
            <h2 class="mb-3">{{ produtDetail.name }}</h2>

            <div class="mb-2">
              <!-- Offer price -->
              <span
                v-if="produtDetail.offerPrice"
                class="h4 me-2"
              >
                ₹{{ produtDetail.offerPrice }}
              </span>

              <!-- Original price -->
              <span
                :class="{
                  'h4': !produtDetail.offerPrice,
                  'text-muted text-decoration-line-through': produtDetail.offerPrice
                }"
              >
                ₹{{ produtDetail.price }}
              </span>
            </div>

            <p class="text-muted">{{ produtDetail.shortDescription }}</p>

            <!-- Quantity -->
            <div class="d-flex align-items-center mb-4">
              <label class="me-3 fw-bold">Quantity:</label>
              <div class="input-group" style="width:120px;">
                <button class="btn btn-outline-secondary" type="button">-</button>
                <input type="text" class="form-control text-center" value="1">
                <button class="btn btn-outline-secondary" type="button">+</button>
              </div>
            </div>

            <div class="d-flex gap-3 mb-4">
              <button class="btn btn-cart" @click="addProductToCart(produtDetail, false)">
                <i class="fa fa-shopping-cart"></i> Add to Cart
              </button>
              <button class="btn btn-buy" @click="addProductToCart(produtDetail, true)">Buy Now</button>
            </div>

            <p><strong>Category:</strong> Keychains</p>
            <p><strong>Tags:</strong> Handmade, Gift, Accessories</p>
          </div>

        </div>
      </div>
    </section>

    <!-- DESCRIPTION / REVIEWS -->
    <section class="py-5 pt-0">
      <div class="container">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active" id="desc-tab" data-bs-toggle="tab" data-bs-target="#desc" type="button" role="tab">Description</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="review-tab" data-bs-toggle="tab" data-bs-target="#review" type="button" role="tab">Reviews</button>
          </li>
        </ul>
        <div class="tab-content border p-3" id="myTabContent">
          <div class="tab-pane fade show active" id="desc" role="tabpanel">
            <p>This handmade keychain is crafted from eco-friendly materials and designed to last.</p>
          </div>
          <div class="tab-pane fade" id="review" role="tabpanel">
            <p><strong>John D.</strong> – "Loved the craftsmanship!"</p>
            <p><strong>Priya K.</strong> – "Great quality and fast delivery."</p>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import { useToast } from 'vue-toast-notification';
const $toast = useToast();
import ProductService from "../services/ProductService";
import { EventBus } from '@/eventBus'

export default {
  name: 'ProductDetail',

  data() {
    return {
      slug: this.$route.params.slug,
      produtDetail: null,
      activeImage: ""
    };
  },

  methods: {
    getProductDetail() {
      ProductService.getProductDetail({ slug: this.slug })
        .then((response) => {
          this.produtDetail = response.data.data;

          // Set main image = first image from backend array
          if (this.produtDetail.images?.length > 0) {
            this.activeImage = this.produtDetail.images[0];
          }
        })
        .catch((e) => {
          $toast.error(e.response.data.respones_msg);
        });
    },
    async addProductToCart(product, redirectToCartPage = false) {
      let data = {
        productId: product._id,
        productDetail: product,
        qty: 1,
      };

      await ProductService.addProductToCart(data)
        .then((response) => {
          EventBus.emit('cart-updated')
          $toast.success(response.data.respones_msg);
          if (redirectToCartPage) {
            this.$router.push({ path: '/cart' });
          }
        })
        .catch((e) => {
          $toast.error(e.response.data.respones_msg);
        });
    },
  },

  mounted() {
    this.getProductDetail();
  }
};
</script>

<style scoped>
.py-9 {
    padding-top: 9rem !important;
    padding-bottom: 3rem !important;
}
</style>
